import { lozad } from './modules/components/vendors.js';
import './modules/components/fancybox.js';
utils.beforeDom();
utils.resolveIconsSpriteHref();

document.addEventListener('DOMContentLoaded', () => {
    utils.onDom();

    (() => {
        const observer = lozad('.lozad', {
            enableAutoReload: true,
            load(element) {
                if (element.nodeName.toLowerCase() === 'img' && element.closest) {
                    const picture = element.closest('picture');
                    if (picture) {
                        picture.querySelectorAll('source[data-srcset]').forEach((source) => {
                            const dataSrcset = source.getAttribute('data-srcset');
                            if (dataSrcset) {
                                source.setAttribute('srcset', dataSrcset);
                            }
                        });
                    }
                }
                if (element.getAttribute('data-src')) {
                    element.src = element.getAttribute('data-src');
                }
                if (element.getAttribute('data-srcset')) {
                    element.setAttribute('srcset', element.getAttribute('data-srcset'));
                }
                if (element.getAttribute('data-background-image')) {
                    element.style.backgroundImage = `url(${element.getAttribute('data-background-image')})`;
                }
                if (element.getAttribute('data-toggle-class')) {
                    element.classList.toggle(element.getAttribute('data-toggle-class'));
                }
            }
        });
        observer.observe();
    })();
});
